var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-stream"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.22531 9.42513V20.0681C4.22531 20.6204 4.67303 21.0681 5.22531 21.0681H18.7745C19.3268 21.0681 19.7745 20.6204 19.7745 20.0681V9.42513M1.63379 10.9924L11.386 3.40921C11.7471 3.12844 12.2527 3.12844 12.6137 3.40921L22.366 10.9924",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.928ec30fc87c82c256d846575ec955c8.svg";
export { ForwardRef as ReactComponent };